<template>
  <div class="flex flex-col w-full border-blue-800 border-8 px-2 lg:px-0">

           <ring-loader v-if="showLoader"></ring-loader>

      <div class="flex justify-center items-center mt-10 mb-10 w-full px-2 lg:pl-20">

            
         
            <label class="mr-5"><strong>{{$t('profile.profilePicture')}}: </strong></label>

            <button   class=" text-center rounded-lg p-5 bg-pink-400" @click="onFileButtonClicked">Upload Image</button>

            <circle-loader v-if="isLoadingImage"></circle-loader>

            <!-- <div v-if="!isLoadingImage"> -->

                <img :src="userInfo.picture" class="ml-5 rounded-lg" height="100" id="profileImage" ref="profileImageRef" width="100"/>
            <!-- </div> -->

            <input type="file"  accept="image/*" style="display: none;" ref="fileInput" @change="getImageEvent">

            <!-- <p v-if="isLoadingImg"> {{uploadingPercentage}}</p> -->
            <!-- <input type="file" class="text-center rounded-lg p-5 bg-pink-400" accept="image/x-png,image/gif,image/jpeg"> -->
                <!-- <dropzone class="text-center rounded-lg p-5 bg-pink-400 " id="drop1" :options="dropOptions"></dropzone> -->

      </div>


      <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.firstName')}}: </strong></label>

            
            <input v-model="firstName"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
             type="text" :placeholder="`${$t('profile.firstName')}`" >
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.lastName')}}: </strong></label>

            
            <input v-model="lastName"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
             type="text" :placeholder="`${$t('profile.lastName')}`" >
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="mr-5" ><strong>{{$t('profile.dateOfBirth')}}: </strong></label>

            
            <input  v-model="dateOfBirth"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
             type="Date" :placeholder="`${$t('profile.dOB')}`">
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.gender')}}: </strong></label>

            <div 
          class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
              >              
              <input type="radio" name="gender" value="male" checked> {{$t('profile.male')}}<br>
              <input type="radio" name="gender" value="female"> {{$t('profile.female')}}<br>
            </div>
      </div>

        <div class="flex flex-col lg:flex-row justify-center items-center mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.phone')}} </strong></label>

            <div  v-if="$countryCode == 'KW'" class="flex overflow-x-scroll lg:overflow-x-visible lg:h-20"
             style="height:120px;">
              <div class="self-start w-full">
                <vue-tel-input  v-model="phone" :defaultCountry ="defaultCountry" @country-changed="countryChanged"
                class="lg:ml-0 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block
                appearance-none leading-normal text-center w-64 lg:w-64"
                  @input="phoneChanged"
                ></vue-tel-input>
              </div>
            </div>

            <div v-else class="flex overflow-x-scroll lg:overflow-x-visible lg:h-20"
             style="height:120px;">
              <div class="self-start lg:self-center w-full">
                <vue-tel-input  v-model="phone" :defaultCountry ="'GB'" @country-changed="countryChanged"
                  class="lg:ml-0 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg
                  py-2 px-4 block appearance-none leading-normal text-center w-64 lg:w-64"
                  @input="phoneChanged"
                ></vue-tel-input>
              </div>
            </div>
            <!-- <input v-model="phone"
            class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block
             appearance-none leading-normal text-center w-40 lg:w-64"
             type="tel" placeholder="Phone Number"> -->
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.nationality')}}: </strong></label>
            
            <country-select v-model="nationality" :country="nationality" topCountry="KW" :countryName="true"
            class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block
            appearance-none leading-normal text-center w-40 lg:w-64"
            />

          <!-- <input v-model="nationality"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block
         appearance-none leading-normal text-center w-40 lg:w-64"
            type="text" placeholder="Country"> -->
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.address')}}: </strong></label>

            
            <input v-model="address"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
             type="text" :placeholder="`${$t('profile.address2')}`">
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label v-if="$countryCode == 'KW'" class="mr-5"><strong>{{$t('profile.civilId')}}: </strong></label>

            <label v-else class="mr-5"><strong>{{$t('profile.id')}}: </strong></label>
            
            <input v-model="identification_number"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
             type="number" lang="en" :placeholder="`${$t('profile.numerics12')}`">
      </div>

      <!-- <div class="flex justify-center items-center mb-2 lg:mb-10 w-full">
                     
        <label class="mr-5"><strong>{{$t('business.type')}} </strong></label>

        <div class="flex lg:flex-row items-center lg:justify-around flex-col w-full lg:h-64"> 

            <div class="flex flex-col items-center justify-center w-32 lg:w-40 mb-5 lg:mb-0">

            <input type="radio" v-model="radioValue" value="1">
            <label class="text-pink-800">{{$t('profile.client')}}</label>
            </div>
            
            <div class="flex flex-col items-center justify-center w-32 lg:w-40 mb-5 lg:mb-0">

            <input type="radio" v-model="radioValue" value="2">
            <label class="text-pink-800">{{$t('profile.business')}}</label>
            </div>

            <div class="flex flex-row items-center justify-center w-32 lg:w-40 mb-5 lg:mb-0">

            <input type="radio" v-model="radioValue" value="3">
            <label class="text-pink-800">{{$t('profile.both')}}</label>
            </div>
          </div>      
      </div> -->
    
      <div class="items-center mb-20">

        <button @click="uploadFileToFireBase"
        class="mt-10 lg:mt-30 w-24 lg:w-1/3 lg:rounded-full rounded bg-pink-500 text-white font-bold p-4 uppercase border-blue-500 border">
        {{$t('profile.save')}} </button>
      </div>
 
  </div>
</template>

<script>

// import dropzone from "vue2-dropzone";
// import 'vue2-dropzone/dist/vue2Dropzone.css'
// import uploadImage from 'vue-upload-image';

import firebase from '../classes/firebase';

// import BaseProgress from './BaserProgress';
// import ProgressBar from 'vuejs-progress-bar';

import { RingLoader } from 'vue-spinners-css';
import { CircleLoader } from 'vue-spinners-css';

import myUpdates from '../hasura/myUpdates';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import componentsHelpers from '../classes/componentHelpers';

export default {

  props: {

    callReload: {
          
          type: Function
        },

    tokenId: '',
    email: '',
   userInfo:{
      
      type: Object,
      default: () => ({})
            },  },
  components: {

    // BaseProgress
    RingLoader,
    CircleLoader
  },

  created(){

  },

  mounted(){

    // if(this.userInfo.is_client == true && this.userInfo.is_business == true){

    //   this.radioValue = 3;
    // }
    // else if(this.userInfo.is_client == true){

    //   this.radioValue = 1;
    // }else if(this.useerInfo.is_business == true){

    //   this.radioValue = 2;
    // }

    let phone = this.userInfo.in_phone.substring(this.userInfo.in_phone.indexOf(' ') + 1);

    // console.log(`phone is: ${phone}`);

    phone = phone.substring(phone.indexOf(' ') + 1);

    // console.log(`phone is: ${phone}`);

    this.phone = phone.replace(' ', '');

    // console.log(`phone is: ${this.phone}`);

    //  console.log(`***********inside update and tokenId is ${JSON.stringify(this.tokenId)}`);
    //  console.log(`***********full Phone is${JSON.stringify(this.userInfo.in_phone)}`);

    // console.log(`***********Phone is${JSON.stringify(this.userInfo.in_phone.substring(this.userInfo.in_phone.lastIndexOf(' ')))}`);


    },
  methods: {

  
  async checkForm(){

     if(this.isLoadingImage == true){

        componentsHelpers.toastIt(this.$toasted, this.$t('profile.imageAlert'), 3, 'outline', true);
        // alert("Image isn't uploaded yet");

        return false;
    }       
      else if(!this.firstName || this.firstName === ''){
          
          componentsHelpers.toastIt(this.$toasted, this.$t('profile.firstNameAlert'), 3, 'outline', true);
          // alert("First Name is required");

          return false;
      }
      else if(!this.lastName || this.lastName === ''){
          
          componentsHelpers.toastIt(this.$toasted, this.$t('profile.lastNameAlert'), 3, 'outline', true);
          // alert("last Name is required");

          return false;
      }
      else if(!this.phone || this.phone === '' || this.phone.length < 8){
        
        componentsHelpers.toastIt(this.$toasted, this.$t('profile.phoneDigitsAlert'), 3, 'outline', true);
        // alert("Enter your 8 digits phone number");

        return false;
      }
      else if(isNaN(this.phone.replace(' ', ''))){

          componentsHelpers.toastIt(this.$toasted, this.$t('profile.invalidPhoneAlert'), 3, 'outline', true);
      }
      else if(!this.address || this.address === ''){
          
        componentsHelpers.toastIt(this.$toasted, this.$t('profile.emptyAddressAlert'), 3, 'outline', true);
        // alert("Address can't be empty");

        return false;
      }

      // else if(!this.identification_number || this.identification_number.address === '' || this.identification_number.length != 12){
          
      //     componentsHelpers.toastIt(this.$toasted, this.$t('profile.civilIdAlert'), 3, 'outline', true);
      //     // alert("Please enter your Civil ID of 11 numbers");

      //     return false;
      // }
      else{

        return true;
      }
  },

   async submitUserInfo(){
      
      // console.log(`phone: ${this.phone.replace(' ', '')}`);
       if(this.isLoadingImage == true){

        componentsHelpers.toastIt(this.$toasted, this.$t('profile.imageAlert'), 3, 'outline', true);
        // alert("Image isn't uploaded yet");
      }
                
      else if(!this.firstName || this.firstName === ''){
          
          componentsHelpers.toastIt(this.$toasted, this.$t('profile.firstNameAlert'), 3, 'outline', true);
          // alert("First Name is required");
      }

      else if(!this.lastName || this.lastName === ''){
          
          componentsHelpers.toastIt(this.$toasted, this.$t('profile.lastNameAlert'), 3, 'outline', true);
          // alert("last Name is required");
      }
      
        else if(!this.phone || this.phone === '' || this.phone.length < 8){
          
          componentsHelpers.toastIt(this.$toasted,  this.$t('profile.phoneDigitsAlert'), 3, 'outline', true);
          // alert("Enter your 8 digits phone number");
      }
      else if(isNaN(this.phone.replace(' ', ''))){

          componentsHelpers.toastIt(this.$toasted,  this.$t('profile.invalidPhoneAlert'), 3, 'outline', true);
      }
        else if(!this.address || this.address === ''){
          
          componentsHelpers.toastIt(this.$toasted,  this.$t('profile.emptyAddressAlert'), 3, 'outline', true);
          // alert("Address can't be empty");
      }
      // else if(!this.identification_number || this.identification_number.address === '' || this.identification_number.length != 12){
          
      //     componentsHelpers.toastIt(this.$toasted, this.$t('profile.civilIdAlert'), 3, 'outline', true);
      //     // alert("Please enter your Civil ID of 11 numbers");
      // }

      else{

          // await  alert (`type of dateOfBirth is ${typeof(this.dateOfBirth)} and dateOfBirth is ${this.dateOfBirth}`);

          // await  alert (`type of email is ${typeof(this.email)} and email is ${this.email}`);

          // await  alert (`type of nationality is ${typeof(this.nationality)} and nationality is ${this.nationality}`);

          try{


            this.showLoader = true;

            let result = await this.signUpMutate();

            // console.log(`result: ${JSON.stringify(result)}`);


          if(this.mutationError != ''){

            this.mutationError = '';
          }

          // const userId = result.data.update_user.returning[0].id;
        
          if(typeof result != 'undefined'){

            if(result.data == 'Updating profile was successful')
            {

              // componentsHelpers.toastIt(this.$toasted, 'Your profile was successfuly updated', 2, 'bubble', true);

              // alert ('Your profile was successfuly updated');

              componentsHelpers.toastIt(this.$toasted,
                this.$t('profile.profileSuccessfulUpdate'),
                2, 'bubble', true);

                const callReload = this.callReload;

                setTimeout(function(){
                  callReload() 
                }, 3000);
            }
            else{
                
                componentsHelpers.sendError(this.$apollo, 0,'Profile', 'profileUpdate', 'submitUserInfo', 
                'Updating profile was not successful');
                
                componentsHelpers.toastIt(this.$toasted, this.$t('profile.somethingWrongRefresh'), 3, 'outline', true);

                // alert ('Error: Something might have went wrong. Refresh the page');
            }
          }

            this.showLoader = false;
          }catch(e){

            this.showLoader = false;

            componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'profileUpdate', 'submitUserInfo', e);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
         }


          // console.log(`Result is ${JSON.stringify(result)}`);

          // console.log(`Result is ${Object.keys(result)}`);

      }
    },

    countryChanged(phoneObject){

      this.defaultCountry = phoneObject.iso2;
      this.countryCode = phoneObject.dialCode;

      // console.log(`country changed to: ${JSON.stringify(this.defaultCountry)}`);
    },

    phoneChanged(value, phoneObject){

      this.defaultCountry = phoneObject.country.iso2;

      // console.log(`this.defaultCountry: ${this.defaultCountry}`);

      this.countryCode = `${phoneObject.country.dialCode} `;
    },



    async signUpMutate(){


      let defaultCountry = this.defaultCountry;
      
      defaultCountry = defaultCountry.replace (' ', '');

      let countryCode = this.countryCode;

      countryCode = countryCode.replace (' ', '');

      // console.log(`defaultCountry: ${defaultCountry}`);

      // console.log(`country code: ${countryCode}`);
      
      let noSpacePhone = this.phone;

      noSpacePhone = noSpacePhone.replace(' ', '');

      // console.log(`this.phone: ${noSpacePhone}`);


      this.countrycode = this.countryCode.replace('+', '');
      //   console.log(`phone: ${this.phone}`);

       const inPhone = `${defaultCountry} +${countryCode} ${noSpacePhone}`; 
      // console.log(`InPhone: ${inPhone}`);

      // console.log(`full phone: ${inPhone}`);

      const phone = `${this.countryCode}${noSpacePhone}`.replace('+','').replace(' ','');

      // console.log(`phone: ${phone}`);

      if(defaultCountry =='KW' && phone.length != 11){

        componentsHelpers.toastIt(this.$toasted, this.$t('profile.invalidKuwaitNumber'), 3, 'outline', true);

        // alert(`invalid Kuwait Number; Number must be 8 digits`);
      }


      // let isClient = true;
      // let isBusiness = false;
      

      // if(this.radioValue == 2){

      //   let isClient = false;
      // let isBusiness = true;

      // }else if(this.radioValue == 3){

      //   let isClient = true;
      //   let isBusiness = true;
      // }

      let img = this.$refs.profileImageRef;

      let imgSrc = '';

      if(img){

        imgSrc = img.src;
      }

      let userInsertResult; 

      try{

        const variables = {

            name: this.fullName,
            address: this.address,
            phone: phone,
            inPhone: inPhone,
            email: this.email,
            nationality: this.nationality,
            gender: this.gender,
            idNumber: this.identification_number,
            picture: imgSrc,
            date_of_birth: this.dateOfBirth,
            tokenId: this.tokenId,
            userId: this.userInfo.id,
          },

        userInsertResult = await axios({method: 'post',
        
          url: '/pnadiapi/profile/updateProfile',

          data: {
            
            variables

          }});

        // userInsertResult = await this.$apollo.mutate({

        //   mutation: myUpdates.user_update,

        //   variables: {

        //     name: this.fullName,
        //     address: this.address,
        //     phone: phone,
        //     inPhone: inPhone,
        //     email: this.email,
        //     nationality: this.nationality,
        //     gender: this.gender,
        //     idNumber: this.identification_number,
        //     picture: img.src,
        //     date_of_birth: this.dateOfBirth,
        //     tokenId: this.tokenId,
        //   },
              
        //   error(error){

        //     this.showLoader = false;
        //     this.mutationError = error;
        //     console.log(JSON.stringify(error));
        //   }
        // });

        // console.log(`userInsertResult: ${JSON.stringify(userInsertResult)}`);
        return userInsertResult;
      }
      catch(error){

          this.showLoader = false;

          this.mutationError = error;


          // const componentsHelpers = componentsHelpers;

          const apollo = this.$apollo;

          const toasted = this.$toasted;

          const userId = this.userInfo.id;

          const phone = this.phone;

          if(this.mutationError.message.includes('unique constraint "user_phone_key"'))
          {

            componentsHelpers.sendError(apollo, userId,'Profile', 'profileUpdate', 'signUpMutate',
             `Error: Phone is already registered: ${phone}`);

            componentsHelpers.toastIt(toasted, this.$t('profile.phoneAlreadyRegisteredError'), 3, 'outline', true);

            // alert (`Error: Phone is already registered`);
          }
          // console.log(`Fayez Error is ${JSON.stringify(error.message)}`);
        }
    },

    onFileButtonClicked(){

      this.$refs.fileInput.click();
    },

getImageEvent(event){

      let img = this.$refs.profileImageRef;

      const fileReader = new FileReader();
      
      fileReader.addEventListener('load', () => {

        img.src = fileReader.result
        // this.picture = fileReader.result;
        this.isLoadingImage = false;

        // console.log(` picture is ${this.picture}`);
      });

      // const componentsHelpers = componentsHelpers;

          const apollo = this.$apollo;

          const toasted = this.$toasted;

          const userId = this.userInfo.id;

          const t = this.$t;

      fileReader.onerror = function(event) {
        
        this.isLoadingImage = false; 

        componentsHelpers.sendError(apollo, userId,'Profile', 'profileUpdate', 'getImageEvent', error);

        componentsHelpers.toastIt(toasted,  this.$t('profile.phoneAlreadyRegisteredError'), 3, 'outline', true);
        // alert(' Image could not be loaded');
      };
      
      if(event.target.files.length > 0){

        this.imageFile = event.target.files[0];

        this.isLoadingImage = true;
        fileReader.readAsDataURL(this.imageFile);
      }

    },

    uploadFileToFireBase(){
    
      let img = this.$refs.profileImageRef;

      const submitFunction = this.submitUserInfo;

      // console.log(`Hi Im here and img is ${img}`);
      
      //get file
      let getFile = this.imageFile;

      if(this.checkForm()){

        if(getFile != null){

          let fileExtension = getFile.name.substr(getFile.name.lastIndexOf('.'));
        //set storage ref

        // const targetLocation = 'p-nadi/images/'+this.email + `(User)/${this.email + ' PC ' + new Date().getTime()+ fileExtension}`;
          const targetLocation = 'p-nadi/images/'+ this.email + `(User)/${this.email}` + ' - PC' + `${fileExtension}`;
             
          // console.log(`Target location is ${targetLocation}`);

          let storageRef = firebase.storage().ref(targetLocation);

          // console.log(`storageRef is ${storageRef}`);
          
          this.isLoadingImage = true;
          let task = storageRef.put(getFile);

          // const componentsHelpers = componentsHelpers;

          const apollo = this.$apollo;

          const toasted = this.$toasted;

          const t = this.$t;

          const userId = this.userInfo.id;

          task.on('state_changed',
            function progress(snapshot){
              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;

              // this.uploadingPercentage = percentage + '%';
              
              // this.uploadingPercentage = this.uploadingPercentage + 10;

              this.isLoadingImage = false;

              // componentsHelpers.toastIt(this.$toasted, 'Image could not be loaded', 3, 'outline', true);
              // console.log(`percentage is ${percentage}`);
            },
            function error(err){
              // console.log(err);
              
              componentsHelpers.sendError(apollo, userId,'profile', 'profileUpdate', 'uploadFileToFireBase taskOn-1', err);

              componentsHelpers.toastIt(toasted, this.$t('profile.loadedImageError'), 3, 'outline', true);
              // aler('Image could not be loaded');

              this.isLoadingImage = false;
            },
            function complete(res){
              //  console.log(`complete upload with ${res}`);
              

              // console.log(`all url objects are ${task.snapshot.ref}`);
              task.snapshot.ref.getDownloadURL().then((url)=>{
                
                this.isLoadingImage = false;

                this.picture = url.toString();

                img.src = this.picture;

                // console.log(`Img source is ${this.picture}`);

                submitFunction();

              });
            }
          );


          task.then(snapshot => {
            this.isLoadingImage = false;
          }).catch(error => {

            this.isLoadingImage = false;

            componentsHelpers.sendError(apollo, userId,'Sessions', 'profileUpdate', 'uploadFileToFireBase taskOn-2', error);

            componentsHelpers.toastIt(toasted, this.$t('profile.errorOccured'), 3, 'outline', true);
            // alert('Error has occured. Try again later');
          });
        }
        else{

          submitFunction();
        } 
      }
    }
  },

  computed: {

    fullName()
    {

      return this.firstName + ' ' + this.lastName;
    }
  },

  data: function() {

    return {


      showLoader: false,

      // firstName: localStorage.hasOwnProperty('name') ? localStorage.getItem('name').split(' ')[0] : '',

      // lastName: localStorage.hasOwnProperty('name') ? localStorage.getItem('name').split(' ')
      
      firstName: this.userInfo.name ? this.userInfo.name.split(' ')[0] : '',

      lastName: this.userInfo.name ? this.userInfo.name.split(' ')

      [this.userInfo.name.split(' ').length - 1] : '',

      dateOfBirth:  this.userInfo.date_of_birth,
      nationality: this.userInfo.nationality,
      gender: this.userInfo.gender,
      // phone: this.userInfo.in_phone.substring(this.userInfo.in_phone.substring(this.userInfo.in_phone.indexOf(' ')).indexOf(' ')),
      phone: '',
      picture: this.userInfo.picture,
      address: this.userInfo.address,
      identification_number: this.userInfo.identification_number,
      userTypes: [false, false, false],
      countryCode: this.userInfo.in_phone.substring(this.userInfo.in_phone.indexOf('+'), this.userInfo.in_phone.lastIndexOf(' ')),
      defaultCountry: this.userInfo.in_phone.substring(0, this.userInfo.in_phone.indexOf('+')-1),

      isLoadingImage: false,
      mutationError: '',
      radioValue: 1,
    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>